import { State } from "../../interfaces";
import {
  AppSettingsDto,
  ContactUsRequest,
  DeleteAccountRequest,
  UpdateAppSettingsRequest,
} from "../../interfaces/app-settings";
import {
  ActionTypes,
  GENERATE_SEQUENCE_NUMBER,
  GENERATE_SEQUENCE_NUMBER_ERROR,
  GENERATE_SEQUENCE_NUMBER_SUCCESS,
  GET_APP_SETTINGS,
  GET_APP_SETTINGS_ERROR,
  GET_APP_SETTINGS_SUCCESS,
  UPDATE_APP_SETTINGS,
  UPDATE_APP_SETTINGS_ERROR,
  UPDATE_APP_SETTINGS_SUCCESS,
} from "./actionTypes";

export class AppSettingsState {
  updateAppSettings!: State<UpdateAppSettingsRequest>;
  appSettings!: State<AppSettingsDto>;
  publicPrivacyPolicy!: State<AppSettingsDto>;
  deleteAccountRequest!: State<DeleteAccountRequest>;
  contactUs!: State<ContactUsRequest>;
  sequenceNumber!: any;

  constructor() {
    this.updateAppSettings = {
      loading: false,
      error: null,
      success: false,
    };
    this.appSettings = {
      loading: false,
      error: null,
      success: false,
    };
    this.publicPrivacyPolicy = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteAccountRequest = {
      loading: false,
      error: null,
      success: false,
    };
    this.contactUs = {
      loading: false,
      error: null,
      success: false,
    };
    this.sequenceNumber = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: AppSettingsState = new AppSettingsState();

export const appSettings = (
  state: AppSettingsState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_APP_SETTINGS:
      state = {
        ...state,
        appSettings: {
          ...state.appSettings,
          loading: true,
          success: false,
          error: null,
        },
        updateAppSettings: {
          ...state.updateAppSettings,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_APP_SETTINGS_SUCCESS:
      state = {
        ...state,
        appSettings: {
          ...state.appSettings,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_APP_SETTINGS_ERROR:
      state = {
        ...state,
        appSettings: {
          ...state.appSettings,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPDATE_APP_SETTINGS:
      state = {
        ...state,
        updateAppSettings: {
          ...state.updateAppSettings,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_APP_SETTINGS_SUCCESS:
      state = {
        ...state,
        updateAppSettings: {
          ...state.updateAppSettings,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
        appSettings: {
          ...state.appSettings,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case UPDATE_APP_SETTINGS_ERROR:
      state = {
        ...state,
        updateAppSettings: {
          ...state.updateAppSettings,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GENERATE_SEQUENCE_NUMBER:
      state = {
        ...state,
        sequenceNumber: {
          ...state.sequenceNumber,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GENERATE_SEQUENCE_NUMBER_SUCCESS:
      state = {
        ...state,
        sequenceNumber: {
          ...state.sequenceNumber,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GENERATE_SEQUENCE_NUMBER_ERROR:
      state = {
        ...state,
        sequenceNumber: {
          ...state.contactUs,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
